console.log('component-pdp-add-to-cart-upsell loaded');

window.addEventListener('variant-change', (event) => {
    // get upsell metafield for the current variant
    const variant = event.detail.variant;
    const metafields = window.theme?.productMetafieldsForUpsell?.productMetafields?.variantMetafields || [];
    const found = metafields.find(v => v.variant_id == variant.id);
    const upsellMetafield = found?.closet_add_ons || [];

    // get upsell product description metafield for the current product
    const productDescriptionForUpsellPopup = upsellMetafield[0]?.upsell_product_description;

    // only continue if metafields exist and have content
    if (!upsellMetafield.length) {
        // console.log('No upsell metafields for this variant');
        return;
    }

    const addToCartButton = document.getElementById('add-to-cart-with-upsell');
    if (addToCartButton) {
        addToCartButton.onclick = (e) => {
            //e.preventDefault();
            window.theme.skipMinicart = true;  // skip opening minicart on add to cart

            // get quantity selected
            const quantityInput = document.querySelector('input[name="quantity"]');
            const quantity = quantityInput.innerText || quantityInput.value || 1;

            // Populate popup
            const container = document.getElementById("upsell-items");
            const buttonsContainer = document.getElementById("upsell-buttons");

            container.innerHTML = ""; // clear old
            buttonsContainer.innerHTML = "";

            const item = upsellMetafield[0];   // just show first for now

            container.insertAdjacentHTML("beforeend", `
            <div class="upsell-product-wrapper">
              <div class="upsell-product">
                <div class="upsell-product_image-wrapper">
                  <img src="${item.variant.featured_image?.src || ''}" width="200px" height="200px"/>
                </div>
                <div class="upsell-product_info-button-wrapper">
                  <div class="upsell-product_info">
                    <a href="${item.product.handle}?variant=${item.variant.id}" class="upsell-product_title">${item.product.title || ''}</a>                    
                    <p class="upsell-product_variant_title">${item.variant.title || ''}</p>
                    <div class="upsell-product_description">${productDescriptionForUpsellPopup || item.product.description || ''}</div>
                    <div class="upsell-product_price-wrapper">
                    <p class="upsell-product_price">${formatMoney(item.variant.price)} each</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>`);
            buttonsContainer.insertAdjacentHTML("beforeend", `
                <button class="upsell-product_no-thanks-button">
                    <span>Maybe Later</span>
                </button>
                <component-addtocart data-handle="${item.product.handle}">
                    <form action="/cart/add" method="post">
                        <input type="hidden" name="id" value="${item.variant.id}">
                        <input type="hidden" name="quantity" value="${quantity}">
                        <input type="hidden" name="properties[tag_value]" value="upsell-popup">
                        <button class="upsell-product_add-to-cart-button" type="submit" name="add" data-keep-label="true">   
                        Add ${quantity} to cart - ${formatMoney(item.variant.price * quantity)}
                        </button>
                    </form>
                </component-addtocart>`);

            // Show popup
            document.getElementById("upsell-popup").style.display = "flex";
            document.getElementById("upsellPopupOverlay").style.display = "block";

            // Hide popup when clicking outside, or on close button, or on Add to cart button  
            document.getElementById("upsellPopupOverlay").onclick = closeUpsellPopupAndOpenMinicart;
            document.querySelector("#upsell-popup .close").onclick = closeUpsellPopupAndOpenMinicart;
            document.querySelector("#upsell-popup .upsell-product_add-to-cart-button").onclick = closeUpsellPopupAndOpenMinicart;
            document.querySelector("#upsell-popup .upsell-product_no-thanks-button").onclick = closeUpsellPopupAndOpenMinicart;
        };
    }
});

function closeUpsellPopupAndOpenMinicart() {
    document.getElementById("upsell-popup").style.display = "none";
    document.getElementById("upsellPopupOverlay").style.display = "none";
    window.theme.skipMinicart = false;
    window.theme.mini_cart._openMinicart(0, true);
}